import { num, money, moneyM, pct, unit, perUnit, perYr } from "./numfmt";
/**
 * F3 RULED (Jun 2026) — firm capacity is stated on the AMBIENT-DERATED plant,
 * everywhere. The nameplate is published beside it (never instead of it) with
 * the conditions that produced the derate, because CAPEX, the equipment
 * schedule and the N+1 unit count are all priced on installed kW.
 *
 * One author for the sentence, so the tile, the build-up card, MixCompare and
 * the PDF cannot drift apart. Returns null when the engine published no
 * derate (hybrid gas banks carry none).
 */

export const firmBasis = (model) => {
  const derated = Number(model?.firm_capacity_available_kw);
  const installed = Number(model?.firm_capacity_installed_kw);
  const pct = Number(model?.firm_capacity_derate_pct);
  if (!Number.isFinite(derated) || !Number.isFinite(installed) || !(pct > 0)) return null;
  const amb = model.firm_capacity_derate_ambient || {};
  return {
    derated, installed, pct,
    tempC: Number(amb.temp_c ?? 0),
    altitudeM: Number(amb.altitude_m ?? 0),
  };
};

const n = (v) => num(Math.round(v), 0);

/** "55,200 kW derated · 60,000 kW installed (35 °C, 100 m — 8.0% derate)" */
export const firmBasisPair = (model, language = "en") => {
  const b = firmBasis(model);
  if (!b) return null;
  const fr = language === "fr";
  const s = fr ? "\u00a0" : " ";
  return `${n(b.derated)}${s}kW ${fr ? "déclassés" : "derated"} · ${n(b.installed)}${s}kW `
         + `${fr ? "installés" : "installed"} (${num(b.tempC, 0, 0)}${s}°C, ${n(b.altitudeM)}${s}m — `
         + `${fr ? "déclassement de " : ""}${pct(b.pct, 1)}${fr ? "" : " derate"})`;
};

/** The full assumption sentence, for cards and report notes. */
export const firmBasisNote = (model, language = "en") => {
  const pair = firmBasisPair(model, language);
  if (!pair) return null;
  return language === "fr"
    ? `Capacité ferme indiquée sur la centrale déclassée\u00a0: ${pair}. Le CAPEX, `
      + `la liste d'équipements et le comptage N+1 sont établis sur les kW installés.`
    : `Firm capacity is stated on the ambient-derated plant: ${pair}. CAPEX, the `
      + `equipment schedule and the N+1 unit count are priced on installed kW.`;
};

// A8 (30 Oct) — the derate applied to the plant's generators (ambient / altitude), as a percentage.
export const generatorDeratePct = (model) =>
  model?.firm_capacity_derate_pct != null ? Number(model.firm_capacity_derate_pct)
    : Number(model?.genset_derate_applied || 0) * 100;

// A8 (30 Oct) — the period TCO, NPV and LCOE run over; mirrors backend lcoe.HORIZON_YEARS.
export const ANALYSIS_YEARS = 20;
